// Generated by scripts/generate-icons.ts
/* eslint-disable */

// This file is auto-generated. Do not edit manually.
import React from 'react';
import { BaseIcon } from '../src/components/BaseIcon';
import type { IconDefinition, IconPath } from '../src/types/IconData.types';

const iconData: IconDefinition = {
  name: "Play",
  viewBox: "0 0 24 24",
  paths: [
    {
      d: "M17.931 11.118c.455.255.682.383.775.541a.68.68 0 0 1 0 .682c-.093.158-.32.286-.775.542l-9.174 5.16c-.366.206-.55.309-.7.308a.56.56 0 0 1-.482-.283c-.075-.13-.075-.34-.075-.76V6.692c0-.42 0-.631.075-.761.099-.173.283-.281.483-.283.15-.001.333.102.7.308z"
    }
  ]
};

export const PlayIcon: React.FC<React.SVGProps<SVGSVGElement> & { iconPathClassName?: string }> = (props) => {
  return <BaseIcon icon={iconData} {...props} />;
};
